import { combineEpics, ofType } from "redux-observable";
import { mergeMap, catchError } from "rxjs/operators";
import { of } from "rxjs";
import { observableGET, observablePOST } from "@/api/apiClient";
import {
  featurePlanFailure,
  featurePlanRequest,
  featurePlanSuccess,
  expandListPlanRequest,
  expandListPlanSuccess,
  expandListPlanFailure,
  subscriptionPaymentRequest,
  subscriptionPaymentSuccess,
  subscriptionPaymentFailure
} from "./subscription";

const featurePlanRequestEpic = (action$) =>
  action$.pipe(
    ofType(featurePlanRequest.type),
    mergeMap(() => {
      return observableGET(`/feature-ad-plan`).pipe(
        mergeMap((response) => {
          return of(featurePlanSuccess(response.data));
        }),
        catchError((error) => of(featurePlanFailure(error)))
      );
    })
  );
const expandListPlanRequestEpic = (action$) =>
  action$.pipe(
    ofType(expandListPlanRequest.type),
    mergeMap(() => {
      return observableGET(`/expand-listing-plan`).pipe(
        mergeMap((response) => {
          return of(expandListPlanSuccess(response.data));
        }),
        catchError((error) => of(expandListPlanFailure(error)))
      );
    })
  );

const subscriptionPaymentEpic = (action$) =>
  action$.pipe(
    ofType(subscriptionPaymentRequest.type),
    mergeMap((action) => {
      return observablePOST(`/payment/create-checkout-session`, {
        body: action.payload
      }).pipe(
        mergeMap((response) => {
          return of(subscriptionPaymentSuccess(response.data));
        }),
        catchError((error) => of(subscriptionPaymentFailure(error)))
      );
    })
  );

const subscriptionEpic = combineEpics(
  featurePlanRequestEpic,
  expandListPlanRequestEpic,
  subscriptionPaymentEpic
);

export default subscriptionEpic;
